// extracted by mini-css-extract-plugin
export default {"mainDiv":"ChangeLanguage_mainDiv__NWM5Z","heading":"ChangeLanguage_heading__gnxKL","content":"ChangeLanguage_content__1sVRa"};